import React, { Component } from 'react';
import { NavLink } from "react-router-dom";

class TabSettings extends Component {
    render() { 
        return ( 
            <div className="overflow-auto">
                
                <div className="mt-6 flex">
                    <NavLink to="/settings/info" className="tab flex-shrink-0">
                        Legal Info & Policy
                    </NavLink>
                    <NavLink to="/settings/administrators" className="tab flex-shrink-0">
                        Administrators
                    </NavLink>
                    <NavLink to="/settings/settlements" className="tab flex-shrink-0">
                        Settlements
                    </NavLink>
                    {/* 
                    <NavLink to="/settings/integrations" className="tab flex-shrink-0">
                        Integrations
                    </NavLink>
                     */}
                </div>

            </div>
        );
    }
}

export default TabSettings;